import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Table, InputGroup, Input, Pagination, Button } from 'rsuite';
import EditRule from '../../modals/EditRuleModal'; // Import the modal component
import CreateRule from '../../modals/CreateRuleModal'; // Import the modal component
import { useAuth} from '../../AuthContext';
import { toast } from 'react-toastify';
import SearchIcon from '@rsuite/icons/Search';

const { Column, HeaderCell, Cell } = Table;

function PricePage() {
  const [activePage, setActivePage] = useState(1);
  const [showEditModal, setShowEditModal] = useState(false); // Control modal visibility
  const [showCreateModal, setShowCreateModal] = useState(false); // Control modal visibility
  const [selectedRule, setSelectedRule] = useState(null); // Store selected row data
  const [priceRules, setPriceRules] = useState([]);
  const [loading, setLoading] = useState(false);
  const { auth } = useAuth();
  const [page, setPage] = useState(0);  
  const [totalPages, setTotalPages] = useState(1);  
  const [searchInput, setSearchInput] = useState('');  

  const handleRowClick = (rowData) => {
    setSelectedRule(rowData); // Pass the row data to the modal
    setShowEditModal(true); // Show the modal
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false); // Close the modal
    setSelectedRule(null); // Clear selected row data
  };

  const handleCloseCreateModal = () => {
    setShowCreateModal(false); // Close the modal
  };
  

  const handleRuleEdited = (updatedRule) => {
    setShowEditModal(false);
    fetchPriceRules(page, searchInput);
    // Update your data state if necessary
  };
  const handleRuleCreated = (updatedRule) => {
    setShowEditModal(false);
    fetchPriceRules(page, searchInput);
    // Update your data state if necessary
  };

  const fetchPriceRules = async (currentPage = 0, source = '') => {
    setLoading(true);

    try{
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pricerules/rules?page=${currentPage}&size=15&source=${encodeURIComponent(source)}`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.token}`
        }
      });

      if(response.ok){
        const data = await response.json();
        setPriceRules(data.content);
        setPage(data.number);
        setTotalPages(data.totalPages);
      }
      else{
        const errorText = await response.text();
        throw new Error(`Misslyckade att hämta prisregler: ${errorText}`);
      }
    }catch(error){
      toast.error(error.message, {
        position: 'bottom-right'
      });
    } finally{
      setLoading(false);
    }
  }
  function search(source) {
    setSearchInput(source);  // Update the searchInput state
    setPage(0);              // Reset to the first page
    fetchPriceRules(0, source); // Fetch the first page with the search term
  }

  useEffect(() => {
    fetchPriceRules();
  }, [])

  return (
    <>
      <Helmet>
        <title>{`Prisfilter`}</title>
      </Helmet>
      <div className="px-5 pt-4 w-100">
        <h4 className="mb-2">Prisregler</h4>
        <p className="text-muted">Översikt av alla priser på infosite.se.</p>
        <hr />
        <div className="d-flex justify-content-end">
          <div className="d-flex mb-2">
            <Button className='me-2' color='orange' appearance="primary" onClick={() => setShowCreateModal(true)}>Skapa prisregel</Button>
            <div>
                <InputGroup>
                    <Input size="md" placeholder={'Sök grossist'} onChange={(value) => search(value)} />
                    <InputGroup.Button>
                    <SearchIcon />
                    </InputGroup.Button>
                </InputGroup>
              </div>
          </div>
        </div>

        <Table
          className="rounded"
          autoHeight
          cellBordered
          data={priceRules}
          bordered
          autoWidth
        >
          <Column flexGrow={1}>
            <HeaderCell>Grossist</HeaderCell>
            <Cell>
              {(rowData) => (
                <span
                  style={{ cursor: 'pointer', textDecoration: 'underline' }}
                  className='text-primary'
                  onClick={() => handleRowClick(rowData)}
                >
                  {rowData.source}
                </span>
              )}
            </Cell>
          </Column>

          <Column width={150} align="center">
            <HeaderCell>Påslag</HeaderCell>
            <Cell dataKey="priceAddon" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>Delticom påslag</HeaderCell>
            <Cell dataKey="delticomAddon" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>Tumstorlek</HeaderCell>
            <Cell dataKey="diameter" />
          </Column>
        </Table>
        <Pagination
          size="md"
          className="mt-2"
          total={totalPages * 15} // 15 is the limit of the results returned
          limit={15}
          activePage={activePage}
          onChangePage={(page) => {
            setActivePage(page);       // Update the active page
            fetchPriceRules(page - 1, searchInput); // Include the current search input
          }}
        />

      </div>

      {/* Render the EditRule modal */}
      {showEditModal && (
        <EditRule
          show={showEditModal}
          handleClose={handleCloseEditModal}
          priceRule={selectedRule}
          onRuleEdited={handleRuleEdited}
        />
      )}
      {showCreateModal && (
        <CreateRule
          show={showCreateModal}
          handleClose={handleCloseCreateModal}
          onRuleCreated={handleRuleCreated}
        />
      )}
    </>
  );
}

export default PricePage;
